import React, { useState } from 'react';
import Layout from '../components/Layout'; // Assuming Layout component exists
import '../assets/css/addUser.css'; // Assuming CSS file exists
import axios from 'axios';

const AddUser = () => {
  const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000'; // Fallback for local dev

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
  });

  const [permissions, setPermissions] = useState([]);

  // Permission options are now objects.
  // 'value' is what the backend schema expects (e.g., 'add_cases').
  // 'label' is what the user sees in the UI (e.g., 'Add Case').
  const permissionOptions = [
    { value: 'add_cases', label: 'Add Case' },
    { value: 'edit_cases', label: 'Edit Case' },
    { value: 'view_cases', label: 'View Case' },
    { value: 'delete_cases', label: 'Delete Case' },
   
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePermissionChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setPermissions((prev) => [...prev, value]);
    } else {
      setPermissions((prev) => prev.filter((p) => p !== value));
    }
  };

  // Resets the form fields and state after a successful submission.
  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      password: '',
    });
    setPermissions([]);
    // Programmatically uncheck all checkboxes for a better UX.
    document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const finalData = {
      ...formData,
      permissions,
    };

    // Get token from localStorage for authorization.
    const userData = JSON.parse(localStorage.getItem('user'));
    const token = userData?.token;

    if (!token) {
        alert('Authentication error. Please log in again.');
        return;
    }

    try {
      // Using async/await for cleaner asynchronous code.
      const response = await axios.post(`${BASE_URL}/api/users`, finalData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      // Provide feedback to the user on success.
      if (response.status === 201) {
        alert('User created successfully!');
        resetForm(); // Reset the form for the next entry.
      }
    } catch (err) {
      // Provide specific error feedback to the user.
      const errorMessage = err.response?.data?.message || 'An error occurred while creating the user.';
      alert(`Error: ${errorMessage}`);
      console.error(err);
    }
  };

  return (
    <Layout>
      <div className="add-user-container">
        <div className="form-wrapper">
          <h1 className="form-title">Add New User</h1>
          <p className="form-subtitle">Create a new user profile with specific permissions.</p>

          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength="6" // Enforcing minlength on the client-side as well
                />
              </div>

              <div className="form-group full-width">
                <label>Permissions</label>
                <div className="permissions-grid">
                  {permissionOptions.map((option) => (
                    <div key={option.value} className="permission-item">
                      <input
                        type="checkbox"
                        id={option.value}
                        value={option.value} // This sends the correct value (e.g., 'add_cases')
                        onChange={handlePermissionChange}
                      />
                      {/* This displays the user-friendly label (e.g., 'Add Case') */}
                      <label htmlFor={option.value}>{option.label}</label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="form-group full-width">
                   <button type="submit" className="submit-btn">
                     Add User
                   </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default AddUser;
